export default __webpack_public_path__ + "static/portfolio-18-1df79bc9fd6f289ca577b220625cfcbe.jpg";